import ReactGA from "react-ga4";

export const initGA = (id) => {
  if (process.env.REACT_APP_PROD === "PROD") {
    ReactGA.initialize(id);
    // ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }
};
